/*
 *  Author: DL
 *  Date: 2020-12-04 12:30:48
 *  Email: dunaliang@fengmap.com
 *  LastEditTime: 2020-12-17 18:44:44
 *  LastEditors: DL
 *  Description:  楼层控件
 *  Copyright: Copyright 2014 - 2020, FengMap, Ltd. All rights reserved.
 */

import React, { useContext } from 'react';
import { BtnGroups } from 'ui';
import Control from '@/components/Control';
import Context from '@/hook/useFmapContext';
import settingConfig from 'config/setting';

const { maxCount } = settingConfig;

export default function() {
    const { fmap, listGroups, focusGroupId } = useContext(Context);

    const handleChangeFloor = function(value) {
        const gid = parseInt(value);
        fmap.changeFloor(gid);
    };

    return (
        <Control>
            <BtnGroups value={focusGroupId} active maxCount={maxCount} data={listGroups.map(({ gid, gname }) => ({ text: gname.toUpperCase(), value: gid }))} onClick={handleChangeFloor} />
        </Control>
    );
}
